import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
document.addEventListener('DOMContentLoaded', function() {
     
    // 初始化Swiper
    var swiper1 = new Swiper(".section1 .swiper", {
        direction: "vertical",
        mousewheel: {
            enabled: true,
            releaseOnEdges: true, // 滚动到边缘时释放鼠标滚轮控制
            forceToAxis: true,    // 只允许纵向滚动
            invert: false,
            sensitivity: 1,
            eventsTarget: 'container'
        },
    });
});


var swiper2 = new Swiper(".section2 .swiper", {
    slidesPerView: 3.75,
    spaceBetween: 20,
    loop:true,
    speed:5000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
        1024: {  //当屏幕宽度小于等于1280
            slidesPerView: 3.75,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }, 
});

